// Globals
import { ReactNode } from 'react';

// Components
import { StyledContent, StyledLayoutWrapper } from './MainLayoutContentStyles';

interface IMainLayoutContent {
  children: ReactNode;
}

const MainLayoutContent = ({ children }: IMainLayoutContent) => (
  <StyledLayoutWrapper>
    <StyledContent>{children}</StyledContent>
  </StyledLayoutWrapper>
);

export default MainLayoutContent;
